import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';

import {
  ButtonDropDownMenuProps,
  DropDownOption,
} from './ButtonDropDownMenu.types';

// const options = [
//   'None',
//   'Atria',
//   // 'Callisto',
//   // 'Dione',
//   // 'Ganymede',
//   // 'Hangouts Call',
//   // 'Luna',
//   // 'Oberon',
//   // 'Phobos',
//   // 'Pyxis',
//   // 'Sedna',
//   // 'Titania',
//   // 'Triton',
//   // 'Umbriel',
// ];

const ITEM_HEIGHT = 48;

export default function ButtonDropDownMenu<T extends DropDownOption>({
  options = [],
  selected,
  children = <MoreVertIcon />,
  onItemClick,
}: ButtonDropDownMenuProps<T>) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        {children}
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            selected={option.id === selected}
            onClick={() => {
              onItemClick?.(option.id);
              handleClose();
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
